import { render } from "./readBookClubCategory.vue?vue&type=template&id=50ad329a&scoped=true"
import script from "./readBookClubCategory.vue?vue&type=script&lang=js"
export * from "./readBookClubCategory.vue?vue&type=script&lang=js"

import "./readBookClubCategory.vue?vue&type=style&index=0&id=50ad329a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ad329a"]])

export default __exports__